import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import Layout from './components/Layout.tsx'
import Home from './pages/Home.tsx'

const Season1 = lazy(() => import('./pages/Season1.tsx'))
const Season2 = lazy(() => import('./pages/Season2.tsx'))
const Game = lazy(() => import('./pages/Game.tsx'))
const Comics = lazy(() => import('./pages/Comics.tsx'))
const Press = lazy(() => import('./pages/Press.tsx'))
const Faq = lazy(() => import('./pages/Faq.tsx'))
const News = lazy(() => import('./pages/News.tsx'))
const Post = lazy(() => import('./pages/Post.tsx'))
const Forums = lazy(() => import('./pages/Forums.tsx'))
const Terms = lazy(() => import('./pages/Terms.tsx'))
const NotFound = lazy(() => import('./pages/NotFound.tsx'))

export default function App() {
  return (
    <Layout>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/season-1/" element={<Season1 />} />
          <Route path="/season-1" element={<Season1 />} />
          <Route path="/season-2/" element={<Season2 />} />
          <Route path="/season-2" element={<Season2 />} />
          <Route path="/game/" element={<Game />} />
          <Route path="/game" element={<Game />} />
          <Route path="/game/termsofuse/" element={<Terms />} />
          <Route path="/game/termsofuse" element={<Terms />} />
          <Route path="/spectrum-comic-book/" element={<Comics />} />
          <Route path="/spectrum-comic-book" element={<Comics />} />
          <Route path="/press/" element={<Press />} />
          <Route path="/press" element={<Press />} />
          <Route path="/faq/" element={<Faq />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/updates/" element={<News />} />
          <Route path="/updates" element={<News />} />
          <Route path="/updates/page/:page/" element={<News />} />
          <Route path="/updates/page/:page" element={<News />} />
          <Route path="/con-man-game-forums/" element={<Forums />} />
          <Route path="/con-man-game-forums" element={<Forums />} />
          <Route path="/404/" element={<NotFound />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/:slug/" element={<Post />} />
          <Route path="/:slug" element={<Post />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Layout>
  )
}
